// Client mirror of the server's progress locks
// (server/src/helpers/training/locks.js). The player uses these to decide
// when Next can be enabled; the server checks again and has the final say.

export const DEFAULT_DWELL_SECONDS = 3
export const MIN_REFLECTION_CHARS = 20

// Screens unlocked by reading time rather than by an activity.
export const DWELL_TYPES = [
  'courseIntro',
  'howToUse',
  'moduleIntro',
  'text',
  'illustration',
  'callout',
  'caseStudy',
  'download',
  'summary',
  'furtherLearning',
  'practicalSignoff',
]

export const isDwellBlock = (block) => DWELL_TYPES.includes(block.type)
export const dwellSecondsFor = (block) => block.minDwellSeconds ?? DEFAULT_DWELL_SECONDS

const hasAll = (needed, given = []) => needed.every((id) => given.includes(id))

// Has the learner done what an activity screen asks? (Reading-time screens
// are timed by the player, not here.)
export const isActivityComplete = (block, state = {}) => {
  switch (block.type) {
    case 'revealCards':
      return hasAll(block.cards.map((card) => card.id), state.revealed)
    case 'hotspot':
      return hasAll(block.spots.map((spot) => spot.id), state.found)
    case 'sequence':
      return Number(state.attempts) >= 1
    case 'match':
      return hasAll(block.items.map((item) => item.id), Object.keys(state.placements ?? {}))
    case 'branchingScenario':
      return !!state.finished
    case 'knowledgeCheck':
      return !!state.submitted && (state.selected ?? []).length > 0
    case 'reflection':
      return block.prompts.every(
        (prompt) => String(state.responses?.[prompt.id] ?? '').trim().length >= MIN_REFLECTION_CHARS,
      )
    case 'video':
      return !!state.watched
    default:
      return true
  }
}

// What the learner still has to do, in words, for the hint under Next.
export const completionHint = (block) => {
  switch (block.type) {
    case 'revealCards':
      return 'Open every card to continue.'
    case 'hotspot':
      return 'Find every area to continue.'
    case 'sequence':
      return 'Put the steps in order and check your answer to continue.'
    case 'match':
      return 'Place every item to continue.'
    case 'branchingScenario':
      return 'Finish the scenario to continue.'
    case 'knowledgeCheck':
      return 'Choose an answer and check it to continue.'
    case 'reflection':
      return `Write at least ${MIN_REFLECTION_CHARS} characters for each prompt to continue.`
    case 'video':
      return 'Watch the video or read the transcript to continue.'
    default:
      return 'Next unlocks in a few seconds.'
  }
}
